/* src/app/shared-components/collapsable-wrapper/collapsable-wrapper.component.scss */
.header-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
.header-collapse {
  background-color: #ffffff;
  padding-top: 1rem;
}
.body-collapse {
  padding-top: 2rem;
  scroll-behavior: smooth;
}
.section-title {
  margin-right: 0.5rem;
}
.title-section-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.info-icon {
  width: 1.25rem;
  height: 1.25rem;
  opacity: 0.32;
}
.btn:focus,
.btn:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
/*# sourceMappingURL=collapsable-wrapper.component.css.map */
